import { useSelector } from 'react-redux';

import { selectChannelById } from 'store/programs/selectors';
import { ReduxStore } from 'store/types';
import { selectLanguage } from 'store/user/selectors';

import parseParentalRating from 'services/data-manager/parsing/utils/parseParentalRating';
import {
    CdvrRecording,
    EventParentalControlRating,
} from 'services/data-manager/types';

import { selectCdvrRecordingMetadataBaseOnLanguage } from 'utils/recordings';

const useCdvrRecordingItemParentalRating = (item: CdvrRecording) => {
    const channel = useSelector((state: ReduxStore) =>
        selectChannelById(state, item.channelId),
    );
    const currentLanguage = useSelector(selectLanguage);

    const metadata = selectCdvrRecordingMetadataBaseOnLanguage(
        item.metadata,
        currentLanguage,
    );

    return (
        (metadata.ratings?.code as EventParentalControlRating) ||
        parseParentalRating(undefined, channel)
    );
};

export default useCdvrRecordingItemParentalRating;
